import { FC, memo, useMemo } from 'react';

import FieldEntry from '../../../../../components/FieldEntry';
import FieldEntryWrapper from '../../../../../components/FieldEntryWrapper/FieldEntryWrapper';
import PreviewSection from '../../../../../components/previewSection/PreviewSection';
import { messages } from './ContactPersonsSection.messages';
import { Content } from './ContactPersonsSection.styles';
import { ContactPersonsSectionProps } from './ContactPersonsSection.types';

const ContactPersonsSection: FC<ContactPersonsSectionProps> = memo((props) => {
    const { contactData } = props;

    const contactValue = useMemo(
        () =>
            [contactData.title, contactData.firstName, contactData.middleName, contactData.lastName, contactData.suffix]
                .filter((item) => item)
                .join(' '),
        [contactData]
    );

    return (
        <PreviewSection header={messages.header}>
            <Content>
                <FieldEntryWrapper>
                    <FieldEntry title={messages.displayName} value={contactData.displayName} />
                </FieldEntryWrapper>

                {contactData.companyName && (
                    <FieldEntryWrapper>
                        <FieldEntry title={messages.companyName} value={contactData.companyName} />
                    </FieldEntryWrapper>
                )}

                {contactValue && (
                    <FieldEntryWrapper>
                        <FieldEntry title={messages.contact} value={contactValue} />
                    </FieldEntryWrapper>
                )}
            </Content>
        </PreviewSection>
    );
});

export default ContactPersonsSection;
